import { getEnvKey } from 'utils/getEnvValue';

const envPrefix = getEnvKey({
  DEV: 'd79eef3bde0445518e995ef57333cd0d_',
  QA: '93aadb18021a441ba7c99eb365b6f7a1_',
  UAT: '28afc672302a4fae8b3988f7f7225dc1_',
  PROD: '',
});

export const convertToBuilderIds = (resources: string[] | null): string[] => {
  if (!resources) {
    return [];
  }
  const modelIdList = [];
  for (let resourceId of resources) {
    switch (resourceId) {
      case 'Article':
        resourceId = '00ae5ef151ff4c9a84ef99e73386381f';
        break;
      case 'Claims Lesson':
      case 'Case Study':
        resourceId = 'b28df6934c7b4d2d9007f285e766546f';
        break;
      case 'Course':
        resourceId = 'fa7c922190244b9a820b0155b7042c89';
        break;
      case 'Podcast':
        resourceId = '4f3d4305f43646a4bb98b29a0705c311';
        break;
      case 'Risk Assessment':
        resourceId = 'fe5725f1ddc049298500953c647dbd62';
        break;
      case 'Risk Report':
        resourceId = '4ef2e04a955a45fbb3fe3223040f8ef1';
        break;
      case 'Toolkit':
        resourceId = 'bb24c5e231a14e259c300e3e8b5e631c';
        break;
      case 'Video':
        resourceId = 'e50a3d2cacf04e43a3ee7537b0286cfd';
        break;
    }
    resourceId = `${envPrefix}${resourceId}`;
    modelIdList.push(resourceId);
  }

  return modelIdList;
};
